import * as React from "react";
function SvgCircleMagnifier(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g fill="none" strokeWidth={2} stroke="currentColor">
        <circle cx={16} cy={16} r={15} strokeMiterlimit={10} />
        <circle cx={14} cy={14} r={5} strokeMiterlimit={10} />
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18l5 5" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleMagnifier);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
